// Follow the open input frame from the top of each side to the timer pill.
export function stakeTimerPaths(width: number, height: number, pill: number) {
  const x0 = 0;
  const x1 = width;
  const y0 = 0;
  const y1 = height;
  const r = 16;
  const mid = width / 2;
  const half = Math.min(pill / 2, mid - r - 8);
  return {
    frame: `M ${x0} ${y0} V ${y1 - r} A ${r} ${r} 0 0 0 ${x0 + r} ${y1} H ${x1 - r} A ${r} ${r} 0 0 0 ${x1} ${y1 - r} V ${y0}`,
    left:
      'M ' +
      x0 +
      ' ' +
      y0 +
      ' V ' +
      (y1 - r) +
      ' A ' +
      r +
      ' ' +
      r +
      ' 0 0 0 ' +
      (x0 + r) +
      ' ' +
      y1 +
      ' H ' +
      (mid - half),
    right:
      'M ' +
      x1 +
      ' ' +
      y0 +
      ' V ' +
      (y1 - r) +
      ' A ' +
      r +
      ' ' +
      r +
      ' 0 0 1 ' +
      (x1 - r) +
      ' ' +
      y1 +
      ' H ' +
      (mid + half),
  };
}
